export default __webpack_public_path__ + "static/media/antimicrobial-confort.33f15106.jpg";